<script>
    import OrderHeader from "./OrderHeader.svelte";

    window.scrollTo(0, 0);
    import {push} from "svelte-spa-router";
    import {order} from "../../js/stores";
    import {onMount} from "svelte";
    import {API_URL} from "../../../env";

    onMount(async () => {
        (function(t, r, a, c, k, i, n, g) {t['ROIDataObject'] = k;
            t[k]=t[k]||function(){(t[k].q=t[k].q||[]).push(arguments)},t[k].c=i;n=r.createElement(a),
                g=r.getElementsByTagName(a)[0];n.async=1;n.src=c;g.parentNode.insertBefore(n,g)
        })(window, document, 'script', '//www.heureka.sk/ocm/sdk.js?version=2&page=thank_you', 'heureka', 'sk');

        heureka('authenticate', '65cea4d12d16bff820af4cfa2d1deceea391');

        heureka('set_order_id', $order.order_id);

        const res = await fetch(API_URL + '/products/' + $order.cart.map(v => v.id).join(','));
        if (!res.ok) return console.error('Fetch error!', await res.json());
        let products = await res.json()
        let total = 0;

        for(const item of $order.cart){
            heureka('add_product', item.id, products.find(p => p.id === item.id).name, item.price, item.count);
            total += parseFloat(item.price) * parseInt(item.count);
        }

        heureka('set_total_vat', total.toFixed(2));
        heureka('set_currency', 'EUR');
        heureka('send', 'Order');
    });

</script>

<section class="container">
    <div class="order">
        <div class="row d-flex justify-content-center">
            <div class="col-lg-10 col-xl-8 col-xxl-6">

                <OrderHeader step={3}/>

                <div class="order-body">
                    <div class="order-created">
                        <i class="far fa-fw fa-check-circle"></i>
                        <h2>Objednávka s číslom <span>#{$order.order_id}</span> bola vytvorená!</h2>
                        <p>Úspešne ste odoslali objednávku a my urobíme všetko pre to, aby ste ju mali doma čo najskôr!</p>
                        <ul>
                            <li><span>{$order?.name} {$order?.surname}</span><span>{$order?.street}</span></li>
                            <li><span>{$order?.email}</span><span>{$order?.zip}, {$order?.city}</span></li>
                            <li><span>{$order?.phone}</span><span>{$order?.country}</span></li>
                            {#if $order.billing_country || $order.company}
                                <br/>
                                <li>
                                    <span>{($order.company)? $order.company : ""}</span>
                                    <span>{($order.billing_street)? $order.billing_street : ""}</span>
                                </li>
                                <li>
                                    <span>{($order.ico)? "IČO: " + $order.ico : ""}</span>
                                    <span>{($order.billing_zip)? $order.billing_zip + ", " : ""}{$order.billing_city || ""}</span>
                                </li>
                                <li>
                                    <span>{($order.dic)? "DIČ: " + $order.dic : ""}</span>
                                    <span>{($order.billing_country)? $order.billing_country : ""}</span>
                                </li>
                                <li>
                                    <span>{($order.ic_dph)? "IČ DPH: " + $order.ic_dph : ""}</span>
                                    <span></span>
                                </li>
                            {/if}
                        </ul>
                    </div>
                </div>
                <div class="order-footer">
                    <div class="footer-buttons">
                        <button class="btn btn-primary" on:click={() => push('/')}>SPÄŤ DO OBCHODU<i class="far fa-fw fa-arrow-right-long ml-2"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .order-created {
        text-align: center;
        background-color: var(--color-slate-50);
        padding: 3rem;
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .order-created i {
        color: #178a21;
        font-size: 6rem;
        margin-bottom: 1rem;
    }
    .order-created h2 {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        margin-bottom: .75rem;
    }
    .order-created h2 span {
        color: var(--color-slate-900);
    }
    .order-created p {
        color: var(--color-slate-600);
        font-family: Rubik, sans-serif;
        font-weight: 300;
        width: 25rem;
        max-width: 100%;
    }
    .order-created ul {
        list-style-type: none;
        padding-left: 0;
        margin-top: 3rem;
        font-family: Rubik, sans-serif;
        font-weight: 300;
        width: 100%;
    }
    .order-created ul li {
        color: var(--color-slate-600);
        text-align: left;
    }
    .order-created ul li span:last-child {
        float: right;
    }
    .order-footer {
        padding: 1.5rem 0;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .order-footer .footer-buttons {
        display: flex;
        flex-flow: row;
        justify-content: end;
        gap: 1rem;
        width: 100%;
        margin-top: .5rem;
    }
</style>